import {
  Dialog as MUIDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

export function DeleteDialog({
  dialogOpen,
  handleCloseDialog,
  handleConfirmEvent,
}) {
  //  const [newEvent, setNewEvent] = useState(null); // holds the clicked time
  //   const [title, setTitle] = useState("");
  //   const [dialogOpen, setDialogOpen] = useState(false);

  //   const handleCloseDialog = () => {
  //     setDialogOpen(false);
  //   };

  //   const handleTitle = (e) => {
  //     setTitle(e.target.value);
  //   };

  //   const handleConfirmEvent = () => {
  //     if (title.trim() && newEvent) {
  //       setEvents((prev) => [...prev, { ...newEvent, title: title.trim() }]);
  //     }
  //     setTitle("");
  //     setNewEvent(null);
  //     setDialogOpen(false);
  //   };

  return (
    <MUIDialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      fullWidth={true}
      maxWidth={"xs"}
    >
      <DialogTitle>Confirm Delete</DialogTitle>

      <DialogActions>
        <Button
          onClick={handleCloseDialog}
          size="small"
          variant="outlined"
          sx={{ textTransform: "capitalize" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirmEvent}
          color="error"
          size="small"
          variant="contained"
          sx={{ textTransform: "capitalize" }}
        >
          Delete
        </Button>
      </DialogActions>
    </MUIDialog>
  );
}
